import Axios from "axios";
//https://o1pobm4pza.execute-api.us-west-1.amazonaws.com/
//http://localhost:5000/
const axiosBaseURL = Axios.create({
  baseURL: "https://accodoc.com/",
});

export default axiosBaseURL;
